import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPause } from '~local/actions';

/* Pause-rendering wrapper — port of `~co/common/withPause`.
   Wrapped component only re-renders while `pause === pauseId`. */
export function withPause(Component) {
  class PauseRender extends React.Component {
    static defaultProps = { pauseId: '' };

    componentDidMount() {
      if (this.props.pauseId && !this.props.pause)
        this.props.setPause(this.props.pauseId);
    }

    componentWillUnmount() {
      if (this.props.pauseId && this.props.pause) this.props.setPause('');
    }

    shouldComponentUpdate(next) {
      if (next.pause !== next.pauseId) return false;
      return true;
    }

    render() {
      const { pause, pauseId, setPause, forwardedRef, ...etc } = this.props;

      return <Component ref={forwardedRef} {...etc} />;
    }
  }

  const WithPause = React.forwardRef(function WithPause(props, ref) {
    const pause = useSelector((state) => state.local.pause);
    const dispatch = useDispatch();
    const setPauseCb = React.useCallback((v) => dispatch(setPause(v)), [
      dispatch,
    ]);

    return (
      <PauseRender
        {...props}
        forwardedRef={ref}
        pause={pause}
        setPause={setPauseCb}
      />
    );
  });

  WithPause.displayName = `withPause(${Component.displayName || Component.name || 'Component'})`;
  return WithPause;
}
